export type Scoped<T> = T & { scopeCustomerId: string };

export function shekelsToAgorot(value: string): number | null {
  const normalized = value.replace(",", ".").trim();
  if (!normalized) {
    return null;
  }
  const num = Number(normalized);
  if (!Number.isFinite(num) || num <= 0) {
    return null;
  }
  return Math.round(num * 100);
}

export function hasFeature(features: readonly string[], key: string): boolean {
  return features.includes(key);
}

export async function loadAcrossCustomers<T>(
  ids: string[],
  loader: (customerId: string) => Promise<T[]>,
): Promise<Scoped<T>[]> {
  const batches = await Promise.all(
    ids.map(async (id) => {
      const items = await loader(id);
      return items.map((item) => ({ ...item, scopeCustomerId: id }));
    }),
  );
  return batches.flat();
}

export const KIND_HE: Record<string, string> = {
  cash_in: "הכנסה",
  cash_out: "הוצאה",
  cash_adjustment: "התאמה",
  fund_transfer: "העברת קרן",
};

export type CashLedgerSection =
  | "ledger"
  | "suppliers"
  | "payment_requests"
  | "documents"
  | "receipts"
  | "bank"
  | "accounting";

export type CashSectionBaseProps = {
  customerId: string | null;
  customerIds: string[];
  customerNames: Record<string, string>;
  writeCustomerId: string;
  archived: boolean;
};
